export const PostsNavLink = 'posts';
